import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { loadPage } from "../../redux/actions/pages";
import { fixExternalLinks } from "../../utils/helper";

class Terms extends Component {
    componentDidMount() {
        this.props.loadPage("terms");
    }

    _renderSection(section) {
        return (
            <div
                className="article-body xl:w-10/12 leading-tight text-17 xl:text-23 mb-30 xl:mb-40 font-bold text-blue"
                dangerouslySetInnerHTML={{
                    __html: fixExternalLinks(section.attributes.body),
                }}
            />
        );
    }

    render() {
        const { termsData } = this.props;

        if (!termsData) return <div className="h-screen" />;

        return (
            <div className="bg-grey mt-100 xl:mt-140 py-60 xl:py-80 px-16 xl:px-50">
                <div className="flex">
                    <div className="xl:w-3/12 xl:mr-16" />
                    <h1 className="font-bold xl:text-center mb-40 text-50 xl:text-60 text-blue">
                        {termsData.title}
                    </h1>
                </div>
                <div className="flex">
                    <div className="xl:w-4/12 xl:mr-16" />
                    {termsData.content.map((section) =>
                        this._renderSection(section)
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    termsData: state.pages.terms,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadPage,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
